<ion-content class="app-sheet">
  <span class="app-tile app-tile--lg app-sheet__tile">
    <app-icon-display
      size=""
      aria-hidden="true"
      [iconType]="'document'" />
  </span>

  <h1 class="app-sheet__title">{{ 'app.documentRequest.sheetTitle' | transloco }}</h1>

  <p class="app-sheet__body">
    {{ 'app.documentRequest.link' | transloco }}
  </p>

  <ion-button
    class="app-cta"
    [disabled]="!notification?.notificationUrl"
    (click)="openExternalWebsiteAsync(notification?.notificationUrl)">
    {{ 'app.documentRequest.text' | transloco }}
  </ion-button>
</ion-content>
